import { Layout, Contact } from '@rumblefish/ui/Rumblefish23Theme';
import type { ContactProps } from './ContactPage.types';

export const ContactPage = ({ blogPosts }: ContactProps) => {
  return (
    <Layout blogPosts={blogPosts}>
      <Contact
        subtitle="Our team is waiting for your message - drop us a line and we'll get back to you within 1 business day!"
        color="raspberry"
      />
    </Layout>
  );
};
